import React, { useCallback } from 'react';
import { Text, Icon, Tooltip, useTheme } from '@Sage/hoi-poi-ui';
const CopilotSidebarAgent = _ref => {
  let {
    agent,
    classes,
    onClick,
    onRemove
  } = _ref;
  const theme = useTheme();
  const onRemoveAgent = useCallback(e => {
    e.stopPropagation();
    onRemove(agent);
    return false;
  }, [agent, onRemove]);
  const onClickAgent = useCallback(() => {
    onClick(agent);
  }, [agent, onClick]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.agent,
    onClick: onClickAgent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.agentHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.agentName
  }, agent.url && /*#__PURE__*/React.createElement(Tooltip, {
    className: classes.tooltip,
    content: agent.url
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
    name: "contentLink",
    color: theme.colors.grey[500]
  }))), /*#__PURE__*/React.createElement(Text, {
    type: "h6",
    isTruncated: true,
    useTooltip: true
  }, agent.name)), /*#__PURE__*/React.createElement(Icon, {
    name: "delete",
    onClick: onRemoveAgent,
    className: classes.deleteIcon
  })), /*#__PURE__*/React.createElement(Text, {
    type: "body"
  }, agent.instructions));
};
export default CopilotSidebarAgent;